import { UPDATE_BOOKING } from "./types";

const updateBooking = (booking) => ({
  type: UPDATE_BOOKING,
  booking,
});

export default updateBooking;
